import { SQLite, SQLiteObject } from '@ionic-native/sqlite';
import { Injectable } from "@angular/core";
import { Constants } from '../commons/constants';

@Injectable()
export class DatabaseConfiguration{

    db: SQLiteObject;

    constructor(private sqlite: SQLite, private constants: Constants){
        
    }

    public initializeDB(){
        return this.sqlite.create({
            name: this.constants.DB_NAME,
            location: this.constants.DB_LOCATION
        })
    }
}


// WEBPACK FOOTER //
// ./src/database/database.configuration.ts